import ShareLotButton from './ShareLotButton';

export default ShareLotButton;



// WEBPACK FOOTER //
// ./src/components/ShareLotButton/index.js